import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ContractDetailsComponent } from '../contract-details.component';
@Component({
  selector: 'app-paid-contract',
  templateUrl: './paid-contract.component.html',
  styleUrls: ['./paid-contract.component.scss']
})
export class PaidContractComponent implements OnInit {

  @Input() contractData: any
  @ViewChild('closeBtn') closeBtn: ElementRef;
  errorMsg: boolean;

  role: any;

  constructor(private contractDetails: ContractDetailsComponent, private appComp: AppComponent, private authService: AuthenticationService, private router: Router) { }

  ngOnInit(): void {

    this.role = this.authService.getUserRole();
  }

  paidContract(){
    this.appComp.loading = true;
    this.errorMsg = false;
    this.contractData.paid = 1;
    console.log(this.contractData);
    delete this.contractData["contractInstallments"];
    this.authService.updateContract(this.contractData).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.appComp.loading = false;
      this.contractDetails.getContractDetails();

    }, err=>{
      console.log(err);
      this.appComp.loading = false;
      this.errorMsg = true;
    })
  }

}
